import * as XLSX from "xlsx-js-style";
import { dateOrStringDateToNumber } from "./dateUtils";

const currencyFormat = {
  numFmt: "$#,##0.00",
};

export function downloadXLSXFile(
  data: any[],
  filename: string,
  customHeaders?: string[]
): void {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);
  if (customHeaders) {
    XLSX.utils.sheet_add_aoa(worksheet, [customHeaders], { origin: "A1" });
  }
  worksheet["!cols"] = calculateColumnWidths(
    data,
    customHeaders ? customHeaders : Object.keys(data[0])
  );

  data.forEach((row, rowIndex) => {
    Object.keys(row).forEach((col, colIndex) => {
      if (typeof row[col] === "number" && colIndex > 0) {
        const cell =
          worksheet[XLSX.utils.encode_cell({ c: colIndex, r: rowIndex + 1 })];
        if (cell) {
          cell.s = currencyFormat;
        }
      }
    });
  });

  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], { type: "application/octet-stream" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function calculateColumnWidths(
  data: any[],
  customHeaders: string[]
): XLSX.ColInfo[] {
  const ADDITIONAL_MARGIN = 5;
  const keys = data.length > 0 ? Object.keys(data[0]) : customHeaders;
  const columnsWidth = keys.map((key, index) => {
    const maxCellWidth = Math.max(
      ...data.map((row: { [x: string]: any }) => String(row[key]).length),
      String(customHeaders[index]).length
    );
    return { wch: maxCellWidth + ADDITIONAL_MARGIN };
  });

  return columnsWidth;
}

export const convertirFechaExcel = (excelDate: number) => {
    if(typeof excelDate !== 'number') return undefined;

    let date = XLSX.SSF.parse_date_code(excelDate);
    date = new Date(date.y, date.m, date.d);
    return dateOrStringDateToNumber(date)?.toString();
};

export const agregarPadStart = (date: string) => {
  const dateSeparated = date.split("/");
  if(dateSeparated[0].length === 1){
      dateSeparated[0] = `0${dateSeparated[0]}`;
  }
  if(dateSeparated[1].length === 1){
      dateSeparated[1] = `0${dateSeparated[1]}`;
  }
  if(dateSeparated[2].length === 2){
      dateSeparated[2] = `20${dateSeparated[2]}`;
  }
  if(parseInt(dateSeparated[1]) > 12){
    return `${dateSeparated[1]}/${dateSeparated[0]}/${dateSeparated[2]}`
  }
  return `${dateSeparated[0]}/${dateSeparated[1]}/${dateSeparated[2]}`
};

export const agregarPadStartDDMMYYYY = (date: string) => {
  const dateSeparated = date.split("/");
  if(dateSeparated[0].length === 1){
      dateSeparated[0] = `0${dateSeparated[0]}`;
  }
  if(dateSeparated[1].length === 1){
      dateSeparated[1] = `0${dateSeparated[1]}`;
  }
  if(dateSeparated[2].length === 2){
      dateSeparated[2] = `20${dateSeparated[2]}`;
  }
  return `${dateSeparated[1]}/${dateSeparated[0]}/${dateSeparated[2]}`
};